export const MAINTENANCE_BASE_PATH = '/api/v1/system/maintenance';
